import { Box, Flex } from '@chakra-ui/react';
import { Switch } from '@mesh.ai/rabbit';
import { useDispatch } from 'react-redux';
import {
  setReviewCreationGridDefinition,
  useGridDefinition,
  useSelectReviewCreationCalibrationAndDeliverables,
  useSelectReviewCreationGridMetaData,
} from 'reducers/reviewCreationV1Slice';
import { generateRows } from 'screens/admin/Reviews/CalibrationSettings/common/helper';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

import { GridOptionsHeader, GridSection } from './PerformanceGridComps';

// if overall score section is there the max score of grid is calculated from that
// if that's not available then we use this mock answer options to use 5 as max score in grid.
const defaultMockAnswerOptions = [{ description: '', score: 5, displayOrder: 5 }];

const PerformanceGrid = () => {
  const { calibrationQuestion, isCalibrationQuestionDisabled } = useSelectReviewCreationCalibrationAndDeliverables();
  const gridDefinition = useGridDefinition();
  const { answerType, answerOptions } = calibrationQuestion ?? {};

  const { rowsCount, columnsCount } = useSelectReviewCreationGridMetaData();

  const isPerformanceGridEnabled = !!gridDefinition;
  const dispatch = useDispatch();

  // eslint-disable-next-line no-shadow
  const calculateGridByMaxValue = ({ newMaxScore, rowsCount, columnsCount }) => {
    // @ts-expect-error wrong function signature
    const newGrid = generateRows({ rows: rowsCount, cols: columnsCount, maxScore: newMaxScore });
    return newGrid;
  };

  const updateGridHandler = (answerOptions) => {
    const maxValue = answerOptions && answerOptions.length > 0 ? answerOptions[answerOptions.length - 1].score : 0;
    const newRowsCount = rowsCount > 0 ? rowsCount : 3;
    const newColumnsCount = columnsCount > 0 ? columnsCount : 3;
    const newGrid = calculateGridByMaxValue({
      rowsCount: newRowsCount,
      columnsCount: newColumnsCount,
      newMaxScore: maxValue,
    });
    dispatch(setReviewCreationGridDefinition(newGrid));
  };

  const onGridDisabledChange = (value: boolean) => {
    // enabling
    if (value) {
      // if user is enabling the outcome questions and there are no answer options, add the default answer options
      if (value && (answerOptions?.length === 0 || !answerOptions)) {
        updateGridHandler(defaultMockAnswerOptions);
        return;
      }

      updateGridHandler(answerOptions);
    } else {
      // disabling
      dispatch(setReviewCreationGridDefinition(null));
    }
  };

  return (
    <Flex borderRadius="8px" flexDir="column" border="4px solid #E7EBEF" bg="white">
      <Flex flexDir="column" py={2} px={3}>
        <Flex
          flexDir="column"
          pb={4}
          borderBottom="1px solid"
          borderColor={isPerformanceGridEnabled ? 'border.CFD7DF' : 'transparent'}
        >
          <TextBodyMedium bold>Performance grid</TextBodyMedium>
          <Flex justifyContent="space-between" alignItems="center">
            <TextLabel color="text.g2">
              The Performance Grid visually maps review results, helping compare employees based on overall scores and
              outcomes.
            </TextLabel>
            <Switch checked={isPerformanceGridEnabled} onCheckedChange={onGridDisabledChange} />
          </Flex>
        </Flex>
      </Flex>

      {isPerformanceGridEnabled && (
        <Box py={2} px={3}>
          <Flex alignItems="center">
            <TextLabel mr={2} bold>
              Select the Performance grid for this cycle
            </TextLabel>
          </Flex>
          <Flex mt={2}>
            {/* <ExpandablePaperBody> */}
            <Flex flexDir="column" maxW="850px" gap="24px">
              <GridOptionsHeader />
              <GridSection />
            </Flex>
            {/* </ExpandablePaperBody> */}
          </Flex>
        </Box>
      )}
    </Flex>
  );
};

export { PerformanceGrid };
